/**
 * SmarterTravel Shared Plugin
 * http://www.smartertravel.com
 *
 * Copyright (c) 2018 10up
 * Licensed under the GPL-2.0+ license.
 */

// Utilities
import 'babel-polyfill';
import ForEachUtility from './utilities/foreach';
import './vendor-utility/jquery.daterangepicker-modified.js';
import './utilities/pollyfill';
import './utilities/event-bus';
// Src
import './src/tracking';
import './src/ads-init';
import mapContainer from './src/map-container';
import tripAdvisor from './src/tripadvisor-pricing';
import DestinationSearchActions from './src/destinations-search-actions';
import './src/outfit-carousel';
import newsletter from './src/newsletter';
import authorBio from './src/author-bio';
import sponsoredLinks from './src/sponsored-links';

// Init
ForEachUtility.init();
mapContainer.init();
newsletter.init();
DestinationSearchActions.init();
tripAdvisor.init();
authorBio.init();
sponsoredLinks.init();
